module.exports = __webpack_public_path__ + "static/gradient-background-2900a973e534ed07bf1c8b6eecd8e6d6.png";